import Marquee from "react-fast-marquee";
import { MARQUEE } from "@/data/property";

export function MarqueeBanner() {
  return (
    <div className="bg-primary text-primary-foreground py-6 md:py-8 overflow-hidden" data-testid="marquee-banner">
      <Marquee speed={40} gradient={false} autoFill>
        {MARQUEE.map((item, i) => (
          <span key={i} className="mx-8 md:mx-12 inline-flex items-center gap-8 md:gap-12">
            <span className="font-display text-3xl md:text-5xl uppercase tracking-tight">{item}</span>
            <span className="h-2 w-2 rounded-full bg-accent" aria-hidden />
          </span>
        ))}
      </Marquee>
    </div>
  );
}
